import { Http } from '@/lib/http';
import { assertRangeRows } from '@/modules/shared/utils/range-row-limits.mjs';
export class LoanLateFeeService extends Http {
  constructor() {
    super();
    this.endpoint = 'loan-pro/settings/loan-late-fees/';
  }

  getLoanLateFeeSettings() {
    return this.httpClient().get(`${this.endpoint}`);
  }
  getLoanLateFeeGeneralSettings() {
    return this.httpClient().get(`${this.endpoint}general-settings`);
  }
  getLoanLateFeeFactors() {
    return this.httpClient().get(`${this.endpoint}factors`);
  }
  getLoanLateFeeOptions() {
    return this.httpClient().get(`${this.endpoint}options`);
  }
  getLoanLateFeeBands() {
    return this.httpClient().get(`${this.endpoint}payment-rates`);
  }
  updateGeneralSettings(data) {
    return this.httpClient().patch(`${this.endpoint}general-settings`, data);
  }
  updateLateFeeBands(data) {
    assertRangeRows(data?.lateFeeRates);
    return this.httpClient().patch(`${this.endpoint}payment-rates`, data);
  }
  updateFactors(data) {
    return this.httpClient().patch(`${this.endpoint}factors`, data);
  }
  updateOptions(data) {
    return this.httpClient().patch(`${this.endpoint}options`, data);
  }
}
